import { collection, onSnapshot, query, where } from "firebase/firestore";
import React, { useEffect, useState } from "react";
import useAuth from "../Auth/useAuth";
import DetailsComponent from "../component/DetailsComponent";
import { db } from "../firebase";

const Dashboard = () => {
  const { user } = useAuth();
  const [studentProfile, setStudentProfile] = useState([]);

  // useEffect(() => {
  //    onSnapshot(doc(db, "studentLists",user.uid ), (doc) => {
  //     let studentArray = [];
  //         studentArray.push( {id:doc.id,...doc.data()});
  //         setStudentProfile(studentArray);
  //     });
  //     },[])

  useEffect(() => {
    const q = query(
      collection(db, "admissionStudentList"),
      where("emailId", "==", user.email)
    );
    onSnapshot(q, (querySnapshot) => {
      let studentArray = [];
      querySnapshot.forEach((doc) => {
        studentArray.push({ id: doc.id, ...doc.data() });
      });
      setStudentProfile(studentArray);
    });
  }, []);

  return (
    <div className="">
      {/* <h1 className="text-left ml-6 pt-3 text-2xl font-semibold">
        Student Profile
      </h1> */}
       <div className="bg-blue-900 sm:hidden h-28 -mt-1"></div>
        <div className="" >
             <div className="hidden sm:block">
             <div className="grid grid-cols-4 gap-2 p-5 ">
           <div className="  text-black text-md font-bold text-center col-span-1">
          <div className="text-center pt-5 ">
            <img
              src="/assets/male.png"
              className="rounded-full w-32 h-32 mb-4 mx-auto"
              alt="Avatar"
            />
          </div>
                 <div className="font-semibold text-black text-md justify-center text-center flex  mt-2 ">         
              <span>{studentProfile[0]?.fullName}</span>
          </div>
          <div className="font-semibold text-black text-md justify-center text-center flex  mt-2 ">         
              <span>Class</span>
              <span className="ml-2">{studentProfile[0]?.studied + " " + " ' "+studentProfile[0]?.classSection +" ' "}</span>                         
          </div>
          <div className="font-semibold text-black text-md justify-center text-center flex  mt-1 ">         
              <span>Roll No.</span>
              <span className="ml-2">{studentProfile[0]?.studentRollNumber}</span>                         
          </div>
        </div>
        <div className="  text-black text-md  font-bold text-center col-span-3 ">
        <div className=" text-left pl-5">
              <span className="block text-black font-bold md:text-left mb-1 md:mb-0 pr-4 text-xl">
               Personal Details
              </span>
            </div>
         <div className="grid grid-cols-2  pl-5 pr-5 ">
            <div className="  text-black text-lg font-bold text-center ">
              <DetailsComponent label="Full Name" inputDetails={studentProfile[0]?.fullName} />
              <DetailsComponent label="Email Id" inputDetails={studentProfile[0]?.emailId} />
              <DetailsComponent label="Date of Birth" inputDetails={studentProfile[0]?.dateOfBirth} />
              <DetailsComponent label="Father's Name" inputDetails={studentProfile[0]?.fathersName} />
              </div>
              <div className="  text-black text-lg font-bold text-center ">
              <DetailsComponent label="Student Code" inputDetails={studentProfile[0]?.studentIdNumber} />
              <DetailsComponent label="Contact No." inputDetails={studentProfile[0]?.phoneNumber} />
              <DetailsComponent label="Aadhaar No." inputDetails={studentProfile[0]?.aadhaarNumber} />
              <DetailsComponent label="Mother's Name" inputDetails={studentProfile[0]?.mothersName} />
              </div>
          </div>
          <div className="w-full p-5">
            <div className=" text-left ">
              <span className="block text-black font-bold md:text-left mb-1 md:mb-0 pr-4 text-xl">
               Permanent Address
              </span>
            </div>
            <div className="grid grid-cols-2  pl-5 pr-5 ">
            <div className="  text-black text-lg font-bold text-center">
            <DetailsComponent label="Address Line 1" inputDetails={studentProfile[0]?.permanentAddressLine} />
            <DetailsComponent label="Apartment/House" inputDetails={studentProfile[0]?.permanentApartmentHouse} />
            <DetailsComponent label="Zip Code" inputDetails={studentProfile[0]?.permanentZip} />
              </div>
              <div className="  text-black text-lg font-bold text-center">
            <DetailsComponent label="Area/Locality" inputDetails={studentProfile[0]?.permanentAreaLocality} />
            <DetailsComponent label="City" inputDetails={studentProfile[0]?.permanentCity} />
            <DetailsComponent label="State" inputDetails={studentProfile[0]?.permanentState} />
              </div>
            </div>
          </div>
          <div className="w-full pl-5 pr-5">
            <div className=" text-left ">
              <span className="block text-black font-bold md:text-left mb-1 md:mb-0 pr-4 text-xl">
               Correspondence Address
              </span>
            </div>
            <div className="grid grid-cols-2  pl-5 pr-5 ">
            <div className="  text-black text-lg font-bold text-center">
            <DetailsComponent label="Address Line 1" inputDetails={studentProfile[0]?.correspondenceAddressLine} />
            <DetailsComponent label="Apartment/House" inputDetails={studentProfile[0]?.correspondenceApartment} />
            <DetailsComponent label="Zip Code" inputDetails={studentProfile[0]?.correspondenceZip} />
              </div>
              <div className="  text-black text-lg font-bold text-center">
            <DetailsComponent label="Area/Locality" inputDetails={studentProfile[0]?.correspondenceAreaLocality} />
            <DetailsComponent label="City" inputDetails={studentProfile[0]?.correspondenceCity} />
            <DetailsComponent label="State" inputDetails={studentProfile[0]?.correspondenceState} />
              </div>
            </div>
          </div>
        </div>
        </div>
              </div>  


          <div className="grid sm:hidden sm:grid-cols-2 -mt-10 sm:mt-5 lg:grid-cols-3 bg-white grid-cols-1 ml-5 mr-5 rounded-lg shadow-lg pb-4 ">
            <div className="flex flex-col -mt-14 sm:mt-5 items-center">
              <div className="w-fit mx-auto">
                <img
                  src="../assets/logo192.png"
                  className="rounded-full w-32 h-32 "
                  alt="profile"
                />
              </div>
            </div>
            <div className="grid">
            <span className="font-bold text-lg"> {studentProfile[0]?.fullName}</span>
              <div className="flex gap-2 justify-center">
                 <h2 className="font-bold text-sm text-right ">Class</h2>
                <h2 className="font-bold text-sm ">:</h2>
                <h2 className="font-bold text-sm text-left ">{studentProfile[0]?.studied}</h2>
                <h2 className="font-bold text-sm text-right ">Section</h2>
                <h2 className="font-bold text-sm ">:</h2>
                <h2 className="font-bold text-sm text-left ">{studentProfile[0]?.classSection}</h2>
                <h2 className="font-bold text-sm text-right ">Roll No.</h2>
                <h2 className="font-bold text-sm ">:</h2>
                <h2 className="font-bold text-sm text-left ">{studentProfile[0]?.studentRollNumber}</h2>
                 </div>
              <div className="grid grid-cols-7 justify-evenly">
                <h2 className="font-bold text-sm text-right col-span-3">Student Code</h2>
                <h2 className="font-bold text-sm col-span-1">:</h2>
                <h2 className="font-bold text-sm text-left col-span-3">{studentProfile[0]?.studentIdNumber}</h2>
              </div>
              <div className="grid grid-cols-7 justify-evenly">
                <h2 className="font-bold text-sm text-right col-span-3">Category</h2>
                <h2 className="font-bold text-sm col-span-1">:</h2>
                <h2 className="font-bold text-sm text-left col-span-3">{studentProfile[0]?.category}</h2>
              </div>
              </div>
            </div>
            <div className="grid sm:hidden  pr-10 pl-10 border-2 shadow-sm m-2">
            <h1 className="text-left -ml-6 font-bold text-xl">Contact Details</h1>
            <div className="grid grid-cols-7 justify-evenly">
                <h2 className="font-bold text-sm text-left col-span-3">Contact No.</h2>
                <h2 className="font-bold text-sm col-span-1">:</h2>
                <h2 className="font-bold text-sm text-left col-span-3">{studentProfile[0]?.phoneNumber}</h2>
              </div>
              <div className="grid grid-cols-7 justify-evenly">
                <h2 className="font-bold text-sm text-left col-span-3">Email Address</h2>
                <h2 className="font-bold text-sm col-span-1">:</h2>
                <h2 className="font-bold text-sm text-left col-span-3">{studentProfile[0]?.emailId}</h2>
              </div>
            <div className="grid grid-cols-7 justify-evenly">
                <h2 className="font-bold text-sm text-left col-span-3">Date Of Birth</h2>
                <h2 className="font-bold text-sm col-span-1">:</h2>
                <h2 className="font-bold text-sm text-left col-span-3">{studentProfile[0]?.dateOfBirth}</h2>
              </div>
              <div className="grid grid-cols-7 justify-evenly">
                <h2 className="font-bold text-sm text-left col-span-3">Father's Name</h2>
                <h2 className="font-bold text-sm col-span-1">:</h2>
                <h2 className="font-bold text-sm text-left col-span-3">{studentProfile[0]?.fathersName}</h2>
              </div>
              <div className="grid grid-cols-7 justify-evenly">
                <h2 className="font-bold text-sm text-left col-span-3">Mother's Name</h2>
                <h2 className="font-bold text-sm col-span-1">:</h2>
                <h2 className="font-bold text-sm text-left col-span-3">{studentProfile[0]?.mothersName}</h2>
              </div>
              
              <div className="">
              <h1 className="text-left -ml-6 font-bold text-lg">Permanent Address</h1>
              <div className="grid grid-cols-7 justify-evenly">
                <h2 className="font-bold text-sm text-left col-span-3">Address Line 1</h2>
                <h2 className="font-bold text-sm col-span-1">:</h2>
                <h2 className="font-bold text-sm text-left col-span-3">{studentProfile[0]?.permanentAddressLine}</h2>
              </div>
              <div className="grid grid-cols-7 justify-evenly">
                <h2 className="font-bold text-sm text-left col-span-3">Area/Locality</h2>
                <h2 className="font-bold text-sm col-span-1">:</h2>
                <h2 className="font-bold text-sm text-left col-span-3">{studentProfile[0]?.permanentAreaLocality}</h2>
              </div>
              <div className="grid grid-cols-7 justify-evenly">
                <h2 className="font-bold text-sm text-left col-span-3">Apartment</h2>
                <h2 className="font-bold text-sm col-span-1">:</h2>
                <h2 className="font-bold text-sm text-left col-span-3">{studentProfile[0]?.permanentApartmentHouse}</h2>
              </div>
              <div className="grid grid-cols-7 justify-evenly">
                <h2 className="font-bold text-sm text-left col-span-3">Zip Code</h2>
                <h2 className="font-bold text-sm col-span-1">:</h2>
                <h2 className="font-bold text-sm text-left col-span-3">{studentProfile[0]?.permanentZip}</h2>
              </div>
              <div className="grid grid-cols-7 justify-evenly">
                <h2 className="font-bold text-sm text-left col-span-3">City</h2>
                <h2 className="font-bold text-sm col-span-1">:</h2>
                <h2 className="font-bold text-sm text-left col-span-3">{studentProfile[0]?.permanentCity}</h2>
              </div>
              <div className="grid grid-cols-7 justify-evenly">
                <h2 className="font-bold text-sm text-left col-span-3">State</h2>
                <h2 className="font-bold text-sm col-span-1">:</h2>
                <h2 className="font-bold text-sm text-left col-span-3">{studentProfile[0]?.correspondenceState}</h2>
              </div>
              </div>
              <div className="">
                <h1 className="text-left -ml-6 font-bold text-lg">Correspondence Address</h1>
              <div className="grid grid-cols-7 justify-evenly">
                <h2 className="font-bold text-sm text-left col-span-3">Address Line 1</h2>
                <h2 className="font-bold text-sm col-span-1">:</h2>
                <h2 className="font-bold text-sm text-left col-span-3">{studentProfile[0]?.correspondenceAddressLine}</h2>
              </div>
              <div className="grid grid-cols-7 justify-evenly">
                <h2 className="font-bold text-sm text-left col-span-3">Area/Locality</h2>
                <h2 className="font-bold text-sm col-span-1">:</h2>
                <h2 className="font-bold text-sm text-left col-span-3">{studentProfile[0]?.correspondenceAreaLocality}</h2>
              </div>
              <div className="grid grid-cols-7 justify-evenly">
                <h2 className="font-bold text-sm text-left col-span-3">Apartment</h2>
                <h2 className="font-bold text-sm col-span-1">:</h2>
                <h2 className="font-bold text-sm text-left col-span-3">{studentProfile[0]?.correspondenceApartment}</h2>
              </div>
              <div className="grid grid-cols-7 justify-evenly">
                <h2 className="font-bold text-sm text-left col-span-3">Zip Code</h2>
                <h2 className="font-bold text-sm col-span-1">:</h2>
                <h2 className="font-bold text-sm text-left col-span-3">{studentProfile[0]?.correspondenceZip}</h2>
              </div>
              <div className="grid grid-cols-7 justify-evenly">
                <h2 className="font-bold text-sm text-left col-span-3">City</h2>
                <h2 className="font-bold text-sm col-span-1">:</h2>
                <h2 className="font-bold text-sm text-left col-span-3">{studentProfile[0]?.correspondenceCity}</h2>
              </div>
              <div className="grid grid-cols-7 justify-evenly">
                <h2 className="font-bold text-sm text-left col-span-3">State</h2>
                <h2 className="font-bold text-sm col-span-1">:</h2>
                <h2 className="font-bold text-sm text-left col-span-3">{studentProfile[0]?.correspondenceState}</h2>
              </div>
              </div>
              </div>          
        </div>
    </div>
  );
};

export default Dashboard;
